var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 1.5C7.035 1.5 5.4375 3.0975 5.4375 5.0625C5.4375 6.99 6.945 8.55 8.91 8.6175C8.97 8.61 9.03 8.61 9.075 8.6175C9.09 8.6175 9.0975 8.6175 9.1125 8.6175C9.12 8.6175 9.12 8.6175 9.1275 8.6175C11.0475 8.55 12.555 6.99 12.5625 5.0625C12.5625 3.0975 10.965 1.5 9 1.5Z",
    fill: "#177C9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.81 10.6127C10.7175 9.21766 7.305 9.21766 5.1975 10.6127C4.245 11.2502 3.72 12.1127 3.72 13.0352C3.72 13.9577 4.245 14.8127 5.19 15.4427C6.24 16.1477 7.62 16.5002 9 16.5002C10.38 16.5002 11.76 16.1477 12.81 15.4427C13.755 14.8052 14.28 13.9502 14.28 13.0202C14.2725 12.0977 13.755 11.2427 12.81 10.6127Z",
    fill: "#177C9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a830089b2b6d8559be8d7451e0c800af.svg";
export { ForwardRef as ReactComponent };